import http from "@/utils/http";

// 分页查询课程包
export function getPackage(data) {
  return http({
    url: "/course/packages" + data,
    method: "GET"
  });
}

// 添加平台课程包
export function addPlatPackage(data) {
  return http({
    url: "/course/plat/package/add",
    method: "POST",
    data
  });
}

// 修改平台课程包
export function updatePlatPackage(id, data) {
  return http({
    url: "/course/plat/package/update/" + id,
    method: "POST",
    data
  });
}

// 添加平台课程
export function addPlatCourse(data) {
  return http({
    url: "/course/plat/add",
    method: "POST",
    data
  });
}

// 修改平台课程
export function updatePlatCourse(id, data) {
  return http({
    url: "/course/plat/update/" + id,
    method: "POST",
    data
  });
}

// 添加备课课程包
export function addPackage(data) {
  return http({
    url: "/course/package/add",
    method: "POST",
    data
  });
}

// 修改备课课程包
export function updatePackage(id, data) {
  return http({
    url: "/course/package/update/" + id,
    method: "POST",
    data
  });
}

// 删除备课包
export function deletePackage(id, data) {
  return http({
    url: "/course/package/delete/" + id,
    method: "POST"
  });
}

// 分页查询课程
export function getCourse(data) {
  return http({
    url: "/courses" + data,
    method: "GET"
  });
}

// 添加备课课程
export function addCourse(data) {
  return http({
    url: "/course/add",
    method: "POST",
    data
  });
}

// 修改备课课程
export function updateCourse(id, data) {
  return http({
    url: "/course/update/" + id,
    method: "POST",
    data
  });
}

// 删除课程
export function deleteCourse(id, data) {
  return http({
    url: "/course/delete/" + id,
    method: "POST"
  });
}

// openPPT
export function openPPTUrl(data) {
  return http({
    url: "/course/pptShowUrl" + data,
    method: "GET"
  });
}

// 添加机构课程
export function addOrgCourse(data) {
  return http({
    url: "/course/org/add",
    method: "POST",
    data
  });
}

// 编辑机构课程
export function updateOrgCourse(id, data) {
  return http({
    url: "/course/org/update/" + id,
    method: "POST",
    data
  });
}

// 添加机构课程包
export function addOrgPackage(data) {
  return http({
    url: "/course/org/package/add",
    method: "POST",
    data
  });
}

// 修改机构课程包
export function updateOrgPackage(id, data) {
  return http({
    url: "/course/org/package/update/" + id,
    method: "POST",
    data
  });
}
